module.exports = __webpack_public_path__ + "assets/img/DataCenter.2a2ae8e6.png";